
import React, { } from "react";
import { useIntl } from "umi";
import { Button, Modal, } from "tea-component";
const ModelModal = (props: any) => {
  const {
    visible,
    title,
    desc,
    onClose,
    onConfirm,
    onCancle,
    confirmText,
    cancelText,
    confirmLoading = false,
    cancelLoading = false,
    showConfirm = true,
    showCancel = true,
    confirmButtonType = 'primary',
    cancelButtonType = 'weak',
    ...restProps
  } = props || {};
  const { formatMessage } = useIntl();
  return <Modal
    visible={visible}
    onClose={onClose}
    {...(restProps || {})}
  >
    <Modal.Body className={'dbl-leave-modal'}>
      <div className="body">
        <div className="body-title">{title}</div>
        <div className="body-text">{desc}</div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      {
        showConfirm && <Button
          type={confirmButtonType}
          loading={confirmLoading}
          onClick={() => {
            onConfirm();
          }}
        >
          {confirmText || formatMessage({ id: 'dbl_common_leave' })}
        </Button>
      }
      {
        showCancel && <Button
          type={cancelButtonType}
          loading={cancelLoading}
          onClick={() => {
            onCancle();
          }}
        >
          {cancelText || formatMessage({ id: 'dbl_common_cancel' })}
        </Button>
      }
    </Modal.Footer>
  </Modal>;
};

export default ModelModal;